import { useState, useCallback } from 'react';

let toastIdCounter = 0;

export function useToast() {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'error') => {
    const id = ++toastIdCounter;
    setToasts((prev) => [...prev, { id, message, type }]);
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const showError = useCallback(
    (message) => showToast(message, 'error'),
    [showToast]
  );

  const showSuccess = useCallback(
    (message) => showToast(message, 'success'),
    [showToast]
  );

  const showInfo = useCallback(
    (message) => showToast(message, 'info'),
    [showToast]
  );

  return {
    toasts,
    showToast,
    showError,
    showSuccess,
    showInfo,
    removeToast,
  };
}





